<template>
  <div class="menu-list">
    <div
      v-for="item in menuList"
      :key="item.id"
      class="menu-item"
      @click="handleClick(item)"
    >
      <img class="menu-item-content-img" :src="item.img" alt="" />
      <span class="menu-item-content-name">{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
import { myMenuList } from "@/utils/const.js";

export default {
  name: "menuList",
  data() {
    return {
      menuList: myMenuList,
    };
  },
  methods: {
    handleClick(item) {
      switch (item.id) {
        case 1:
          this.$router.push({
            name: item.path,
          });
          break;
        case 2:
          this.$router.push({
            name: item.path,
          });
          break;
        case 3:
          if (process.env.VUE_APP_ENV === "productionApp") {
            this.$JSBridge.send("serviceType", { type: "9" });
          } else {
            this.$toast("当前已是最新版本");
          }
          break;
        case 4:
          this.$router.push({
            name: item.path,
          });
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.menu-list {
  margin-top: 30px;
  background: #ffffff;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.03);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 84px;
}
.menu-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  .menu-item-content-img {
    width: 30px;
    height: 30px;
  }
  .menu-item-content-name {
    font-size: 13px;
    font-weight: 400;
    color: #333333;
  }
}
</style>
